var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "progress", style: "height: " + _vm.height + "px" },
    [
      _vm.values.length === 0
        ? _c(
            "div",
            {
              staticClass: "progress-bar",
              class: _vm.computedClasses,
              style: "width: " + _vm.value + "%;",
              attrs: {
                role: "progressbar",
                "aria-valuenow": _vm.value,
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }
            },
            [
              _vm._t("default", [
                _vm.showText
                  ? _c("span", [
                      _vm._v(
                        "\n           " + _vm._s(_vm.value) + "%\n        "
                      )
                    ])
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._l(_vm.values, function(progress) {
            return _c(
              "div",
              {
                key: progress.value,
                staticClass: "progress-bar",
                class: _vm.progressClasses(progress),
                style: "width: " + progress.value + "%;"
              },
              [
                progress.text
                  ? _c("span", [
                      _vm._v("\n         " + _vm._s(progress.text) + "\n      ")
                    ])
                  : _vm._e()
              ]
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-529603dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-529603dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Progress.vue
// module id = Dq3Z
// module chunks = 4